import React, { useEffect, useState } from 'react'
import { clampScore, formatScore, scoreToStars } from './scoreUtils'

const STAR_PATH = 'M10 1.6l2.1 4.3 4.7.7-3.4 3.3.8 4.7L10 12.4 5.8 14.6l.8-4.7L3.2 6.6l4.7-.7L10 1.6z'

export default function StarRating({ score, size = 'sm', animate = false }) {
  const stars = scoreToStars(score)

  return (
    <span className={`quest-stars size-${size}${animate ? ' is-fresh' : ''}`} aria-hidden="true">
      {stars.map((fill, index) => (
        <svg
          key={index}
          viewBox="0 0 20 20"
          className="quest-star-icon"
          style={{ '--i': index }}
        >
          <path className="quest-star-base" d={STAR_PATH} />
          {fill > 0 ? (
            <path
              className="quest-star-fill"
              d={STAR_PATH}
              style={{ clipPath: `inset(0 ${(1 - fill) * 100}% 0 0)` }}
            />
          ) : null}
        </svg>
      ))}
    </span>
  )
}

export function ScoreCount({ score, animate = false }) {
  const target = clampScore(score)
  const [shown, setShown] = useState(() => (animate ? 0 : target))

  useEffect(() => {
    if (target == null) {
      setShown(null)
      return undefined
    }
    if (!animate) {
      setShown(target)
      return undefined
    }
    const start = performance.now()
    const duration = 720
    let frame = 0
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration)
      const eased = 1 - (1 - t) ** 3
      setShown(target * eased)
      if (t < 1) frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [target, animate])

  return <>{formatScore(shown)}</>
}
